import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../Button';
import { Typography } from '../Typography';
import styles from './PaginationControl.module.scss';
export function PaginationControl(props) {
    const { pageSize, pageNumber, total, testId = 'pagination-controls', onPageNumberChange } = props;
    const start = (pageNumber - 1) * pageSize + 1;
    const end = Math.min(pageNumber * pageSize, total);
    const isPreviousDisabled = pageNumber === 1;
    const isNextDisabled = pageNumber === Math.ceil(total / pageSize);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                skin: "secondary",
                testId: "".concat(testId, "-label"),
                children: [
                    "Viewing ",
                    start,
                    "-",
                    end,
                    " of ",
                    total
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                size: "small",
                skin: "primaryOutline",
                disabled: isPreviousDisabled,
                testId: "".concat(testId, "-previous"),
                onClick: ()=>onPageNumberChange(pageNumber - 1),
                children: "Previous"
            }),
            /*#__PURE__*/ _jsx(Button, {
                size: "small",
                skin: "primaryOutline",
                disabled: isNextDisabled,
                testId: "".concat(testId, "-next"),
                onClick: ()=>onPageNumberChange(pageNumber + 1),
                children: "Next"
            })
        ]
    });
}
